<template>
  <div class="ibox animated fadeInRightBig">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Dica</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <span style="font-size: 21px; font-weight: bold; color: #000">
                  <p>
                    Segue abaixo um documento modelo, com campos especiais, de
                    forma a personalizar o seu documento a ser criado. Atente-se
                    para colocar, de forma correta, todos os campos necessários.
                  </p>

                  <div>
                    <a
                      :href="$store.getters.url + '/layouts/modelDocument'"
                      target="_blank"
                      class="btn btn-add-left mr-2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-download"></i> Download Modelo
                    </a>
                  </div>
                  <p>
                    <strong>Observação:</strong> todo campo personalizado deverá
                    ter o seguinte formato:
                    <strong>${CAMPO}</strong>
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="ibox-title" style="padding-top: 5px">
        <h5>Gerar Documento</h5>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <label>Fazer upload do documento (DOCX)</label>
                <input
                  v-show="!documentUrl"
                  type="file"
                  id="signature-document"
                  class="form-control"
                  @change="readDocument"
                />
                <br />
                <button
                  class="btn btn-crud width delete"
                  style="width: 200px"
                  @click="changeFile"
                  v-show="documentUrl"
                >
                  <i class="fas fa-exchange-alt"></i> Alterar arquivo importado
                </button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <iframe
                  :src="documentUrl"
                  frameborder="0"
                  width="100%"
                  height="1000px"
                ></iframe>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="documentUrl">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="mb-5 btn-group w-100"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    :class="[
                      'btn w-50 border border-success',
                      { 'bg-success text-white': document.type_id == 1 },
                    ]"
                    @click="document.type_id = 1"
                  >
                    Normal
                  </button>
                  <button
                    type="button"
                    :class="[
                      'btn w-50 border border-success',
                      { 'bg-success text-white': document.type_id == 2 },
                    ]"
                    @click="document.type_id = 2"
                  >
                    Importação
                  </button>
                </div>
                <div class="row mb-5" v-show="document.type_id == 2">
                  <div class="col-md-12 mb-3">
                    <label
                      >Planilha -
                      <label class="text-danger"> ATENÇÃO <i class='green clickable fa fa-question-circle' data-toggle="collapse" data-target="#attention-collapse" aria-expanded="false" aria-controls="#attention-collapse"></i></label>
                      </label>
                    <input
                      type="file"
                      id="sheet-upload"
                      class="form-control"
                      @change="sheetUploaded"
                    />
                  <div class='row'>
                      <div class='col-12'>
                          <div class="collapse mb-5" id="attention-collapse">
                              <div class="card card-body">
                                  <ol>
                                      <li>A primeira coluna da planilha deve conter a <b>MATRÍCULA</b> dos usuários</li>
                                      <li>Caso exista algum usuário que NÃO esteja cadastrado na plataforma, 
                                          por favor ordene as colunas da planilha na seguinte ordem para que ele seja cadastrado: 
                                          <br><b>MATRÍCULA - NOME - CPF - DATA DE NASCIMENTO - EMAIL - OUTRAS COLUNAS</b>
                                      </li>
                                  </ol>
                              </div>
                          </div>
                      </div>
                  </div>
                  </div>
                  <div class="col-md-6">
                    <label>Data limite para assinatura</label>
                    <date-picker
                      :only-date="true"
                      v-model="batch.limit_date"
                      :output-format="'YYYY-MM-DD'"
                      :format="'YYYY-MM-DD'"
                      :formated="'YYYY-MM-DD'"
                      :auto-close="true"
                      :button-now-translation="'Hoje'"
                      :label="''"
                      :color="'#03a830'"
                    ></date-picker>
                  </div>
                  <div class="col-md-6">
                    <label>Grupo de Visualização</label>
                    <select
                      class="form-control"
                      v-model="batch.viewing_group_id"
                    >
                      <option
                        :value="viewing_group.id"
                        v-for="viewing_group in viewing_groups"
                        :key="viewing_group.id"
                      >
                        {{ viewing_group.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>
                      Escreva o
                      <b>Texto do E-mail</b>
                    </label>

                    <h6>Olá, {nome_do_colaborador}</h6>
                    <textarea
                      rows="10"
                      class="form-control"
                      v-model="batch.email_text"
                    ></textarea>
                  </div>
                  <div class="col-md-12 mt-3">
                    <label></label>
                    <input
                      type="checkbox"
                      class="big-checkbox"
                      v-model="batch.send"
                    />
                    Enviar automaticamente após cadastro
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-md-12">
                    <label>Nome do Documento</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="document.name"
                    />
                  </div>
                </div>
                <div
                  class="row mb-2"
                  v-for="(documentField, index) in documentFields"
                  :key="index"
                >
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      :value="documentField.text"
                      readonly
                    />
                    <label
                      class="float-right"
                      v-show="documentField.field.type_id == 2"
                      >Conteúdo de {{ documentField.text }}:</label
                    >
                    <br />
                  </div>
                  <div class="col-md-6">
                    <select
                      class="form-control"
                      v-model="documentField.field"
                      v-show="
                        !documentField.field || documentField.field.type_id != 9
                      "
                    >
                      <option
                        :value="userField"
                        v-for="(userField, index) in userFields"
                        :key="index"
                      >
                        {{ userField.label }}
                      </option>
                    </select>
                    <select
                      class="form-control"
                      v-model="documentField.content"
                      v-show="
                        documentField.field && documentField.field.type_id == 9
                      "
                    >
                      <option
                        :value="headerItem"
                        v-for="(
                          headerItem, headerIndex
                        ) in availableSheetHeaders"
                        :key="headerIndex"
                      >
                        {{ headerItem }}
                      </option>
                    </select>
                    <input
                      type="text"
                      class="form-control"
                      v-model="documentField.content"
                      v-show="documentField.field.type_id == 2"
                    />
                    <div v-show="documentField.field.type_id == 8">
                      <input
                        type="checkbox"
                        v-model="documentField.dateField"
                      />
                      Campo de data
                    </div>
                    <br />
                  </div>
                  <hr />
                  <br />
                </div>
              </div>
            </div>
            <div class="form-page__footer">
              <div class="form-page__actions">
                <router-link :to="'/documents'" class="btn btn-return">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <button class="btn btn-add" @click="save">
                  <i class="fa fa-save"></i> Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      batch: {
        limit_date: "",
        email_text: "",
        viewing_group_id: "",
        send: 0,
      },
      documentUrl: "",
      document: {
        name: document.getElementById("inputArquivo"),
        type_id: 1,
      },
      enable_file_input: true,
      doc_file: "",
      userFields: [
        {
          id: 1,
          type_id: 1,
          field: "name",
          label: "Usuário - Nome",
          content: "",
        },
        {
          id: 2,
          type_id: 1,
          field: "email",
          label: "Usuário - E-mail",
          content: "",
        },
        {
          id: 3,
          type_id: 1,
          field: "birth_date",
          label: "Usuário - Data de Nascimento",
          content: "",
        },
        {
          id: 4,
          type_id: 1,
          field: "admission_date",
          label: "Usuário - Data de Admissão",
          content: "",
        },
        {
          id: 5,
          type_id: 1,
          field: "register",
          label: "Usuário - Matrícula",
          content: "",
        },
        {
          id: 6,
          type_id: 1,
          field: "professional_career_number",
          label: "Usuário - Número da Carteira de Trabalho",
          content: "",
        },
        {
          id: 7,
          type_id: 1,
          field: "serie",
          label: "Usuário - Série",
          content: "",
        },
        {
          id: 8,
          type_id: 1,
          field: "cpf",
          label: "Usuário - CPF",
          content: "",
        },
        {
          id: 9,
          type_id: 1,
          field: "company.fantasy_name",
          label: "Empresa - Nome",
          content: "",
        },
        {
          id: 10,
          type_id: 1,
          field: "company.cnpj",
          label: "Empresa - CNPJ",
          content: "",
        },
        {
          id: 11,
          type_id: 1,
          field: "company.adress",
          label: "Empresa - Endereço",
          content: "",
        },
        {
          id: 12,
          type_id: 1,
          field: "company.state",
          label: "Empresa - Estado",
          content: "",
        },
        {
          id: 13,
          type_id: 1,
          field: "company.city",
          label: "Empresa - Cidade",
          content: "",
        },
        {
          id: 14,
          type_id: 1,
          field: "company.cep",
          label: "Empresa - CEP",
          content: "",
        },
        {
          id: 15,
          type_id: 1,
          field: "branch.name",
          label: "Unidade - Nome",
          content: "",
        },
        {
          id: 16,
          type_id: 1,
          field: "sector.name",
          label: "Setor - Nome",
          content: "",
        },
        {
          id: 17,
          type_id: 1,
          field: "role.name",
          label: "Cargo - Nome",
          content: "",
        },
        {
          id: 18,
          type_id: 2,
          field: "",
          label: "Campo aberto",
          content: "",
        },
        {
          id: 19,
          type_id: 3,
          field: "",
          label: "Data atual (DD/MM/YYY)",
          content: "",
        },
        {
          id: 20,
          type_id: 4,
          field: "",
          label: "Data atual (DD de MM de YYYY)",
          content: "",
        },
        {
          id: 21,
          type_id: 5,
          field: "",
          label: "Dia atual",
          content: "",
        },
        {
          id: 22,
          type_id: 6,
          field: "",
          label: "Mês atual",
          content: "",
        },
        {
          id: 23,
          type_id: 7,
          field: "",
          label: "Ano atual",
          content: "",
        },
        {
          id: 24,
          type_id: 8,
          field: "",
          label: "Importar Planilha",
          content: "",
        },
        {
          id: 25,
          type_id: 9,
          field: "",
          label: "Campo da Planilha",
          content: "",
        },
      ],
      documentFields: [],
      viewing_groups: [],
      sheetContent: "",
    };
  },
  computed: {
    availableSheetHeaders() {
      return this.sheetContent.header ? this.sheetContent.header.slice(1) : [];
    },
  },
  methods: {
    sheetUploaded() {
      const file = document.getElementById("sheet-upload").files[0];

      if (file) {
        $("#page_loader").show();

        // Insere biblioteca para converter Excel para JSON
        // https://github.com/DHTMLX/excel2json
        // Excel2json is a Rust and WebAssembly-based library that allows easily converting files in Excel format to JSON files.
        const url = window.URL.createObjectURL(
          new Blob(
            [
              "importScripts('https://cdn.dhtmlx.com/libs/excel2json/1.1/worker.js');",
            ],
            { type: "text/javascript" }
          )
        );

        // Instancia um novo Web Worker para processar conversão em background
        const worker = new Worker(url);

        // Envia mensagem para o worker iniciar a conversão
        worker.postMessage({
          type: "convert",
          data: file,
        });

        // Aqui, ficamos ouvindo a mensagem do worker avisando quando a conversão for finalizada
        worker.addEventListener("message", (event) => {
          if (event.data.type === "ready") {
            const self = this;
            try {
              const sheetData = event.data.data;

              const header = sheetData[0].cells[0].map((cell) => cell.v);
              header.unshift("user_id"); // Insere user_id na primeira posição do array do cabeçalho

              const rows = sheetData[0].cells // Acessa conteúdo das linhas da planilha
                .filter((_, i) => i > 0) // Pula linha do cabeçalho
                .filter((row) => {  //removendo linhas que tenham células com valor NULL (limpando registros)
                  let jump = false
                  row.forEach(x => {
                    if(!x){
                      jump = true
                    }
                  })
                  if(jump){
                    return false
                  } else {
                    return true
                  }
                }).map((row) => row.map((cell) => cell.v)); // Retorna conteúdo da célula

              const registers = rows.filter((row) => row[0] ? true : false).map((row) => row[0]);

              const api = self.$store.state.api + "setUserIds";
              self.$http
                .post(api, { header: header, rows: rows, registers: registers })
                .then((response) => {
                  self.sheetContent = response.data.data;
                  self.documentFields.forEach((documentField) => {
                    documentField.field = {
                      id: 25,
                      type_id: 9,
                      field: "",
                      label: "Campo da Planilha",
                      content: "",
                    };
                  });
                  $("#page_loader").hide();
                })
                .catch((error) => {
                  const err = error.response.data;
                  $("#page_loader").hide();

                  self.$message("Erro", err, "error");

                });
            } catch (error) {
              console.error(error);
              self.$message("Erro", error, "error");
              $("#page_loader").hide();
            }
          }
        });
      }
    },
    makeFormData() {
      const self = this;
      const fd = new FormData();

      fd.append("name", self.document.name);

      const document_file = document.getElementById("signature-document")
        .files[0];
      if (document_file) {
        fd.append("document", document_file);
        fd.append("pdf_url", self.documentUrl.replace("?embed=true", ""));
      }

      fd.append("batch[limit_date]", self.batch.limit_date);
      fd.append("batch[email_text]", self.batch.email_text);
      fd.append("batch[viewing_group_id]", self.batch.viewing_group_id);
      fd.append("batch[send]", self.batch.send ? 1 : 0);

      self.documentFields.forEach((documentField, index) => {
        fd.append(
          "fields[" + index + "][field]",
          documentField.field.field || ""
        );
        fd.append("fields[" + index + "][text]", documentField.text || "");
        fd.append(
          "fields[" + index + "][type_id]",
          documentField.field.type_id || ""
        );
        fd.append(
          "fields[" + index + "][content]",
          documentField.content || ""
        );
        fd.append("fields[" + index + "][field_id]", documentField.field.id);

        if (documentField.field.type_id == 8) {
          fd.append(
            "fields[" + index + "][date_field]",
            documentField.dateField ? 1 : 0
          );
        }
      });

      fd.append("type_id", self.document.type_id);

      if (self.document.type_id == 2) {
        // IMPORTAÇÃO
        if (!self.sheetContent)
          throw new Error(
            "Insira uma planilha com usuários válidos(cadastrados)"
          );
        if (!self.sheetContent.rows.length)
          throw new Error(
            "Não foram encontrados usuários válidos na planilha informada"
          );

        const planilha = {
          headers: self.sheetContent.header,
          rows: self.sheetContent.rows,
        };

        fd.append("planilha", JSON.stringify(planilha));
      }

      const id = this.$route.params.id;
      if (id) {
        fd.append("id", id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save() {
      $("#page_loader").show();

      const self = this;
      let api = self.$store.state.api + "signaturedocuments";

      const id = this.$route.params.id;
      if (id) {
        api += "/" + id;
      }

      const fd = self.makeFormData();

      if (!fd) {
        $("#page_loader").hide();
        return;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          // Caso o cadastro seja do tipo 1 (NORMAL) ou o
          // checkbox "Enviar automaticamente após cadastro"
          // não esteja desmarcado, apenas criamos o documento e enviamos
          // o usuário de volta para a Lista de Documentos".
          // Ele pode enviar o lote depois pela tela de Gerenciamento de Lotes.
          if (self.document.type_id == 1 || !self.batch.send) {
            $("#page_loader").hide();

            self.$message("Sucesso", "Documento criado com sucesso", "success");

            self.$router.push("/documents");

            return;
          }

          // Caso o cadastro seja do tipo 2 (IMPORTAÇÃO) e o
          // checkbox "Enviar automaticamente após cadastro"
          // esteja desmarcado, criamos o documento e enviamos
          // o usuário para a tela de detalhe do lote criado
          // passando o job_status_id para ele poder acompanhar
          // o andamento do enfileiramento e status do envio dos e-mails
          // e também o status da assinatura do usuário.

          self.$message("Sucesso", "Documento criado com sucesso", "success");

          self.$router.push(
            `/signaturebatches/view/${response.data.signature_batch_id}?job_status_id=${response.data.job_status_id}`
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    getViewingGroups() {
      const self = this;
      const api =
        self.$store.state.api + "signature_viewing_groups?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.viewing_groups = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    changeFile() {
      swal({
        title: "Deseja alterar o arquivo importado?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, alterar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            break;

          case "confirm":
            this.documentUrl = null;
            break;
        }
      });
    },
    readDocument() {
      $("#page_loader").show();

      const self = this;

      const document_file = document.getElementById("signature-document")
        .files[0];

      this.doc_file = document_file.name;
      this.doc_file = this.doc_file.split(".");

      self.document.name = this.doc_file[0];

      if (!document_file) return;

      const reader = new FileReader();
      reader.onload = function () {
        try {
          const zip = new JSZip(reader.result);
          const doc = new window.docxtemplater().loadZip(zip);
          const documentText = doc.getFullText();

          // Regex para extrair conteúdo das nossas tags customizadas ${EXEMPLO}
          const regex = /\$\{(.*?)\}/g;
          const fields = [];
          let matches = [];
          while ((matches = regex.exec(documentText))) {
            fields.push(matches[1]);
          }
          self.documentFields = self.mountDocumentFields(fields);

          const fd = new FormData();
          fd.append("file", document_file);

          // Aqui chamamos o método da api que vai converter o docx em pdf
          // para ser exibido ao usuário pra ele ver se está tudo certo.
          const api = self.$store.state.api + "docx-to-pdf";
          self.$http
            .post(api, fd)
            .then((response) => {
              self.$message(
                "Sucesso",
                "Documento lido com sucesso. Por favor, preencha os campos",
                "success"
              );
              self.documentUrl = response.data.file_download_uri;
              $("#page_loader").hide();
            })
            .catch((error) => {
              self.$message("Erro", error.response.data, "error");
              document.getElementById("signature-document").value = "";
              $("#page_loader").hide();
            });
        } catch (_) {
          self.$message(
            "Erro",
            "Documento inválido. Por favor, confirme se o documento é um docx válido e tente novamente.",
            "error"
          );
          document.getElementById("signature-document").value = "";
          $("#page_loader").hide();
        }
      };
      reader.readAsBinaryString(document_file);

      reader.onerror = function (e) {
        self.$message("Erro", error.toString(), "error");
        document.getElementById("signature-document").value = "";
        $("#page_loader").hide();
      };
    },
    mountDocumentFields(texts) {
      let documentFields = [];

      texts.forEach((text) => {
        documentFields.push({ text: text, field: "" });
      });

      return documentFields;
    },
    getDocument(id) {
      const self = this;
      const api =
        self.$store.state.api + "signaturedocuments/" + id + "?with[]=fields";
      self.$http
        .get(api)
        .then((response) => {
          self.document = response.data.data[0];

          console.log(response.data.data[0].fields);

          for (let index in response.data.data[0].fields) {
            let field = response.data.data[0].fields[index];

            const foundItem = self.userFields.find(
              (userField) => userField.id == field.field_id
            );

            if (foundItem) {
              field.field = foundItem;
            }
          }

          self.documentFields = response.data.data[0].fields;
          self.documentUrl = response.data.data[0].document_http;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  beforeMount: function () {
    // Insere bibliotecas docxtemplater e jszip que são usadas na extração conteúdo das
    // nossas tags customizadas do docx. ${EXEMPLO}
    const docxtemplater = document.createElement("script");
    docxtemplater.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/docxtemplater/3.1.9/docxtemplater.js"
    );
    document.head.appendChild(docxtemplater);

    const jszip = document.createElement("script");
    jszip.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/jszip/2.6.1/jszip.js"
    );
    document.head.appendChild(jszip);
  },
  mounted: function () {
    const id = this.$route.params.id;
    if (id) {
      this.getDocument(id);
    }
    this.getViewingGroups();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Document/Document.vue